import { render } from "./OdsStatusMessage.vue?vue&type=template&id=528da8fb"
import script from "./OdsStatusMessage.vue?vue&type=script&lang=js"
export * from "./OdsStatusMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__